import { getLtiProviders } from './providers.effects';

import {
  FETCH_PROVIDERS_STARTED,
  FETCH_PROVIDERS_SUCCESS,
  FETCH_PROVIDERS_FAILED,
} from './providers.types';

// fetch all providers
const fetchProvidersStarted = () => ({
  type: FETCH_PROVIDERS_STARTED,
});

const fetchProvidersSuccess = (providers) => ({
  type: FETCH_PROVIDERS_SUCCESS,
  providers,
});

const fetchProvidersError = (error) => ({
  type: FETCH_PROVIDERS_FAILED,
  error,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchLtiProviders = () => async (dispatch) => {
  dispatch(fetchProvidersStarted());

  try {
    const { providers } = await getLtiProviders();
    dispatch(fetchProvidersSuccess(providers));
  } catch (error) {
    dispatch(fetchProvidersError(error));
  }
};
